import type {MaybeRef} from 'vue';

export const permissionKey = 'permissions';

export function permissionListQueryKey(userId: MaybeRef<string | undefined>) {
    return [permissionKey, userId] as const;
}
